'use client'

import { motion } from "motion/react";
import Image from "next/image";
import Link from "next/link";
import { FaFacebook } from "react-icons/fa";

export const Footer = () => {
  return (
    <motion.footer
        className="bg-muted py-12"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        <div className="container mx-auto px-4">
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
            >
              <div className="flex items-center gap-2 mb-4">
                <Image src="/logoschool.png" alt="Janakalyan Boarding School" className="h-8 w-8 object-cover bg-secondary dark:bg-primary rounded-full" width={40} height={40} />
                <span className="text-xl font-bold">Shree Janakalyan Boarding School</span>
              </div>
              <p className="text-sm text-muted-foreground mb-4">
                Nurturing young minds in Pokhara with quality education and cultural values since 1995.
              </p>
              <div className="flex gap-4">
                <motion.a
                  href="https://www.facebook.com/www.jkbs"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-primary"
                  whileHover={{ scale: 1.2, rotate: 5 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <FaFacebook className="size-5" />
                  <span className="sr-only">Facebook</span>
                </motion.a>
                {/* <motion.a
                  href="#"
                  className="text-muted-foreground hover:text-primary"
                  whileHover={{ scale: 1.2, rotate: 5 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <FaInstagram className="size-5" />
                  <span className="sr-only">Instagram</span>
                </motion.a>
                <motion.a
                  href="#"
                  className="text-muted-foreground hover:text-primary"
                  whileHover={{ scale: 1.2, rotate: 5 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <FaTwitter className="size-5" />
                  <span className="sr-only">Twitter</span>
                </motion.a> */}
              </div>
            </motion.div>
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              <h3 className="mb-4 text-lg font-semibold">Quick Links</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link href="/" className="text-muted-foreground hover:text-primary transition-colors">
                    Home
                  </Link>
                </li>
                <li>
                  <Link href="/about" className="text-muted-foreground hover:text-primary transition-colors">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link href="/programs" className="text-muted-foreground hover:text-primary transition-colors">
                    Programs
                  </Link>
                </li>
                <li>
                  <Link href="/gallery" className="text-muted-foreground hover:text-primary transition-colors">
                    Gallery
                  </Link>
                </li>
                <li>
                    <Link href="/testimonials" className="text-muted-foreground hover:text-primary transition-colors">
                        Testimonials
                    </Link>
                </li>
                <li>
                  <Link href="/contact" className="text-muted-foreground hover:text-primary transition-colors">
                    Contact
                  </Link>
                </li>
              </ul>
            </motion.div>
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
            >
              <h3 className="mb-4 text-lg font-semibold">Programs</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link href="/programs" className="text-muted-foreground hover:text-primary transition-colors">
                    Early Childhood
                  </Link>
                </li>
                <li>
                  <Link href="/programs" className="text-muted-foreground hover:text-primary transition-colors">
                    Middle Childhood
                  </Link>
                </li>
                <li>
                  <Link href="/programs" className="text-muted-foreground hover:text-primary transition-colors">
                    Upper Primary
                  </Link>
                </li>
                <li>
                  <Link href="/programs" className="text-muted-foreground hover:text-primary transition-colors">
                    After-School Activities
                  </Link>
                </li>
                <li>
                  <Link href="/programs" className="text-muted-foreground hover:text-primary transition-colors">
                    Summer Programs
                  </Link>
                </li>
              </ul>
            </motion.div>
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
            >
              <h3 className="mb-4 text-lg font-semibold">Office Hours</h3>
              <ul className="space-y-2 text-sm">
                <li className="flex items-center justify-between">
                  <span className="text-muted-foreground">Sunday - Friday:</span>
                  <span>10:00 AM - 4:00 PM</span>
                </li>
                <li className="flex items-center justify-between">
                  <span className="text-muted-foreground">Saturday:</span>
                  <span>Closed</span>
                </li>
              </ul>
              <div className="mt-4 pt-4 border-t">
                <h3 className="mb-2 text-lg font-semibold">Contact</h3>
                <p className="text-sm text-muted-foreground">
                  Phone: +977 9808718289, +977 9846042783
                  <br />
                  Email: admin@janakalyanschool.edu.np, janakalyanboardingschool@gmail.com
                </p>
              </div>
            </motion.div>
          </div>
          <motion.div
            className="mt-8 pt-8 border-t text-center"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.5 }}
          >
            <p className="text-sm text-muted-foreground">
              &copy; {new Date().getFullYear()} Shree Janakalyan Boarding School. All rights reserved.
            </p>
          </motion.div>
        </div>
      </motion.footer>
  );
};
